const isScrollable = ($element: HTMLElement | undefined | null) =>
  $element && $element.clientHeight < $element.scrollHeight;

export default isScrollable;
